import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import Typography from '../../../../components/Typography/Typography'
import LegendItem from './components/LegendItem/LegendItem'
import MobileLegend from './components/MobileLegend/MobileLegend'
import { LEGEND_SEATS } from './constants'
import hocConnect from './hocHallLegend'

import './HallLegend.scss'

const HallLegend = ({ priceCategories, seats, seatsInfoData }) => {
    const intl = useIntl()

    return (
        <Container fluid className="hall-legend">
            <div className="legend-title">
                <Typography variant={'sectionHeadline'} color={'lighterPrimary'}>
                    {intl.formatMessage({ id: 'hall.legend.title' })}
                </Typography>
            </div>
            <div className="legend-mobile-tooltips">
                <MobileLegend type={'move'} />
                <MobileLegend type={'zoom'} />
            </div>
            <div className="legend-content">
                {priceCategories?.map((priceCategory) => {
                    const seat = LEGEND_SEATS.find((seat) => seat.seatIds.includes(priceCategory.price_categoryid))
                    const seatInfoData = seatsInfoData?.find(
                        (seatInfo) => seatInfo.seatId == priceCategory.price_categoryid
                    )
                    return (
                        <LegendItem
                            seatInfoData={seatInfoData}
                            key={`${seat?.type}-${seat?.size}`}
                            type={seat?.type}
                            size={seat?.size}
                            withTooltip={seat?.withTooltip}
                        />
                    )
                })}

                {/*LEGEND_SEATS?.map(
                    ({ type, size, seatIds, withTooltip }) =>
                        checkSeatIncl(seats, seatIds) && (
                            <LegendItem key={`${type}-${size}`} type={type} size={size} withTooltip={withTooltip} />
                        )
                        )*/}
                <LegendItem
                    type={'selected'}
                    seatInfoData={{ seatTitle: intl.formatMessage({ id: 'hall.legend.seat.selected.single' }) }}
                />
                <LegendItem
                    type={'reserved'}
                    seatInfoData={{ seatTitle: intl.formatMessage({ id: 'hall.legend.seat.reserved.single' }) }}
                />
            </div>
        </Container>
    )
}

export default hocConnect(HallLegend)
